import { css } from '@emotion/core';

import SlatThemes from './SlatThemes';
import { BasisFont, PlantinFont, mediumWeight } from '../mixins/typography';
import { DESKTOP_START_QUERY, MOBILE_END_QUERY } from '../mixins/responsive';

/*
 * Themes for use on our landing pages within PBR.
 *
 * Properties are namespaced by the component they are used within:
 *  Current LP components:
 *    * Button
 *    * Slat
 *    * Heading
 */

export const LandingPageTheme = {
  Button: {
    color: 'lapel',
    borderRadius: '0',
  },
  Heading: {
    fontStyleCss: css`
      ${PlantinFont};
    `,
  },
  Slat: {
    layout: SlatThemes.LandingPageSlatTheme,
    marginBottomCss: css`
      margin-bottom: 1rem;

      @media (${MOBILE_END_QUERY}) {
        margin-bottom: 0;
      }

      @media (${DESKTOP_START_QUERY}) {
        margin-bottom: 1.5rem;
      }
    `,
  },
};

export const BasisTheme = {
  Heading: {
    fontStyleCss: css`
      ${BasisFont};
      ${mediumWeight};
    `,
  },
  Slat: {
    layout: SlatThemes.LandingPageSlatTheme,
    marginBottomCss: '',
  },
};

export const FlyerTheme = {
  Button: {
    color: 'gatsby',
    borderRadius: '90px',
  },
  Heading: {
    fontStyleCss: '',
  },
  Slat: {
    layout: SlatThemes.LandingPageSlatTheme,
    isIndented: false,
    marginBottomCss: '',
  },
};

export const VibesPageTheme = {
  Button: {
    color: 'lapel',
    borderRadius: '0',
  },
  Heading: {
    fontStyleCss: '',
  },
  Slat: {
    layout: SlatThemes.VibeSlatTheme,
    marginBottomCss: css`
      margin-bottom: 1rem;
      @media (${DESKTOP_START_QUERY}) {
        margin-bottom: 1.5rem;
      }
    `,
  },
};

export const LandingPageThemes = {
  default: LandingPageTheme,
  LandingPageTheme,
  BasisTheme,
  FlyerTheme,
  VibesPageTheme,
};

export default LandingPageThemes;
